function generateYearArray(maxYear, minYear) {
    if (minYear > maxYear) {
        throw new Error('Min year must be less than max year')
    }

    let year = maxYear
    const years = []
    while (year >= minYear) {
        years.push(year)
        year -= 1
    }

    return years
}

const minBatTrackingDate = '2023-07-14'

// Attempt to make flipping the easy ones, easier. Need to update March 30th value to start of season when schedule comes out
const currentYear = new Date().getFullYear()
const currentDate = new Date()
const firstThresholdDate = new Date(currentYear, 2, 30) // March 30th
const secondThresholdDate = new Date(currentYear, 2, 31) // March 31st - Mike says about three to five days before we flip over to default
const thirdThresholdDate = new Date(currentYear, 3, 10) // April 10th - stuff that might take a bit longer to show up
const fourthThresholdDate = new Date(currentYear, 4, 1) // May 1 - the very late stuff like player affinity visual, games

const firstThresholdYear =
    firstThresholdDate < currentDate ? currentYear : currentYear - 1

const secondThresholdYear =
    secondThresholdDate < currentDate ? currentYear : currentYear - 1

const thirdThresholdYear =
    thirdThresholdDate < currentDate ? currentYear : currentYear - 1

const fourthThresholdYear =
    fourthThresholdDate < currentDate ? currentYear : currentYear - 1

const minStatcastYear = 2015
const minPitchFxYear = 2008

const appSettings = {
    // Home page
    SETTINGS_TOP_PERFORMERS: {
        year: secondThresholdYear,
        years: generateYearArray(firstThresholdYear, minStatcastYear),
    },
    dragDashboard: {
        year: thirdThresholdYear,
    },
    // Batting
    batTracking: {
        year: secondThresholdYear,
        useCache: true,
        years: generateYearArray(firstThresholdYear, 2023),
        minBatTrackingDate,
    },
    battedBall: {
        year: secondThresholdYear,
        useCache: true,
        years: generateYearArray(firstThresholdYear, minStatcastYear),
    },
    exitVelocity: {
        year: secondThresholdYear,
        useCache: true,
        years: generateYearArray(firstThresholdYear, minStatcastYear),
    },
    expectedStats: {
        year: secondThresholdYear,
        useCache: true,
        years: generateYearArray(firstThresholdYear, minStatcastYear),
    },
    homeRunTracking: {
        year: secondThresholdYear,
        useCache: true,
        years: generateYearArray(firstThresholdYear, 2019),
    },
    percentileRankings: {
        year: secondThresholdYear,
        useCache: true,
        years: generateYearArray(firstThresholdYear, minStatcastYear),
    },
    pitchArsenalStats: {
        year: secondThresholdYear,
        min: 1,
        minPitches: 'q',
        useCache: true,
        years: generateYearArray(firstThresholdYear, 2019),
    },
    pitcherArmAngles: {
        year: secondThresholdYear,
        useCache: true,
        years: generateYearArray(firstThresholdYear, 2020),
    },
    pitcherTempo: {
        baseState: 'Bases Empty',
        year: secondThresholdYear,
        minPitches: 'q',
        isTake: 1,
        useCache: true,
        years: generateYearArray(firstThresholdYear, 2010),
    },
    swingTake: {
        year: secondThresholdYear,
        useCache: true,
        years: generateYearArray(firstThresholdYear, minPitchFxYear),
    },
    SETTINGS_YEAR_TO_YEAR: {
        year: secondThresholdYear,
        years: generateYearArray(firstThresholdYear, firstThresholdYear - 8),
        allYears: generateYearArray(firstThresholdYear, 2016),
        useCache: true,
    },
    // Pitchers
    // Takes 100 pitches to show up, so don't have 2025 show up as an option early
    activeSpin: {
        year: thirdThresholdYear,
        useCache: true,
        years: generateYearArray(thirdThresholdYear, 2020),
        min: 50,
    },
    pitchArsenals: {
        year: secondThresholdYear,
        useCache: true,
        spinCutoffYear: 2015,
        years: generateYearArray(firstThresholdYear, minPitchFxYear),
    },
    pitchMovement: {
        year: secondThresholdYear,
        useCache: true,
        years: generateYearArray(firstThresholdYear, 2017),
    },
    // Handles comparison as well
    spinAxis: {
        year: secondThresholdYear,
        useCache: true,
        years: generateYearArray(firstThresholdYear, 2020),
    },
    // FIELDING
    armStrength: {
        // Set because 1B is the longest to qualify @100 throws.
        minThrows: 50,
        year: fourthThresholdYear,
        useCache: true,
        // Start exposing the new year option later than on other leaderboards
        years: generateYearArray(thirdThresholdYear, 2020),
    },
    catcherBlocking: {
        year: secondThresholdYear,
        useCache: true,
        years: generateYearArray(firstThresholdYear, 2018),
    },
    catcherFraming: {
        year: secondThresholdYear,
        useCache: true,
        years: generateYearArray(firstThresholdYear, minStatcastYear),
    },
    catcherFramingOld: {
        year: 2017,
        useCache: true,
        years: generateYearArray(2017, 2015),
    },
    catcherFramingNew: {
        year: secondThresholdYear,
        useCache: true,
        years: generateYearArray(firstThresholdYear, 2018),
    },
    catcherThrowing: {
        year: secondThresholdYear,
        useCache: true,
        years: generateYearArray(firstThresholdYear, 2016),
    },
    SETTINGS_CATCHER_STANCE: {
        firstDate: '2020-07-23',
        firstYear: 2020,
        year: secondThresholdYear,
        useCache: true,
        years: generateYearArray(firstThresholdYear, 2020),
    },
    pitcherRunningGame: {
        year: secondThresholdYear,
        useCache: true,
        years: generateYearArray(firstThresholdYear, 2016),
    },
    fieldingRuns: {
        year: secondThresholdYear,
        years: generateYearArray(firstThresholdYear, 2016),
        minInnings: 100,
    },
    SETTINGS_FIELDING_RUN_VALUE: {
        year: secondThresholdYear,
        years: generateYearArray(firstThresholdYear, 2018),
        firstYear: 2018,
        firstDate: '2018-03-29',
    },
    poptime: {
        year: secondThresholdYear,
        years: generateYearArray(firstThresholdYear, minStatcastYear),
        useCache: true,
        min: 5,
    },
    catchProbability: {
        year: secondThresholdYear,
        useCache: true,
        years: generateYearArray(firstThresholdYear, 2016),
    },
    directionalCatchProbability: {
        year: secondThresholdYear,
        useCache: true,
        years: generateYearArray(firstThresholdYear, 2016),
    },
    infieldDefense: {
        year: secondThresholdYear,
        min: 10,
        useCache: true,
        years: generateYearArray(firstThresholdYear, 2016),
    },
    jump: {
        year: secondThresholdYear,
        useCache: true,
        years: generateYearArray(firstThresholdYear, 2016),
    },
    baseRunning: {
        year: secondThresholdYear,
        useCache: true,
        years: generateYearArray(firstThresholdYear, 2016),
    },
    baseRunningRunValue: {
        year: secondThresholdYear,
        useCache: true,
        years: generateYearArray(firstThresholdYear, 2016),
    },
    basestealingRunningGame: {
        year: secondThresholdYear,
        useCache: true,
        years: generateYearArray(firstThresholdYear, 2016),
    },
    sprintSpeed: {
        year: secondThresholdYear,
        useCache: true,
        years: generateYearArray(firstThresholdYear, minStatcastYear),
        min: 10,
    },
    runningSplits: {
        year: fourthThresholdYear,
        // This doesn't populate in a reasonable time frame, so might need to switch independently after the main `year` prop.
        playerYear: fourthThresholdYear,
        useCache: true,
        min: 5,
        years: generateYearArray(thirdThresholdYear, minStatcastYear),
    },
    SETTINGS_SLBI: {
        year: firstThresholdYear,
        dateMin: `${currentYear}-03-22`,
        dateMax: `${currentYear}-11-01`,
    },
    SETTINGS_ABS: {
        year: firstThresholdYear,
        years: generateYearArray(firstThresholdYear, 2024),
    },
    // This is only powering an old URL that's kept around for scrapers
    oaa: {
        year: firstThresholdYear,
        useCache: true,
    },
    parkFactors: {
        year: secondThresholdYear,
        useCache: true,
        firstWallChangeYear: 2022,
        secondWallChangeYear: 2025,
        years: generateYearArray(firstThresholdYear, 1999),
        statcastyYears: generateYearArray(firstThresholdYear, 2016),
        dimensionYears: generateYearArray(firstThresholdYear, 2015),
        wallChangeDefault: 2024,
        wallChangeYears: generateYearArray(2024, 2022),
        secondWallChangeYears: generateYearArray(secondThresholdYear, 2025),
    },
    sortableStats: {
        year: secondThresholdYear,
        useCache: true,
        years: generateYearArray(firstThresholdYear, 1950),
    },
    // /statcast_hit_probability
    breakdown: {
        year: secondThresholdYear,
        useCache: true,
        years: generateYearArray(firstThresholdYear, minStatcastYear),
    },
    pitchTimerInfractions: {
        year: secondThresholdYear,
        useCache: true,
        years: generateYearArray(firstThresholdYear, 2023),
    },
    // /replay
    replay: {
        year: firstThresholdYear, // I think this is pretty immediately what you're interested in.
        useCache: true,
        years: generateYearArray(firstThresholdYear, 2014),
    },
    // NON LEADERBOARD PLACES
    SETTINGS_STATISTICS_MENU: {
        currentYear: firstThresholdYear,
        years: generateYearArray(firstThresholdYear, firstThresholdYear - 5),
        statcastYears: generateYearArray(firstThresholdYear, minStatcastYear),
    },
    SETTINGS_DERBY: {
        year: 2025,
        years: generateYearArray(2025, 2017),
    },
    draft: {
        year: 2025,
        years: generateYearArray(2025, 1965),
    },
    games: {
        currentYear: fourthThresholdYear,
    },
    illustrator: {
        currentYear: firstThresholdYear,
        years: generateYearArray(firstThresholdYear, minStatcastYear),
    },
    league: {
        year: firstThresholdYear,
        years: generateYearArray(firstThresholdYear, minStatcastYear),
    },
    team: {
        year: firstThresholdYear,
        years: generateYearArray(firstThresholdYear, minStatcastYear),
    },
    playerScroll: {
        year: secondThresholdYear,
    },
    // I feel like these should always have a year selected, but perhaps I'm wrong.
    searchCharts: {
        year: firstThresholdYear,
    },
    SETTINGS_METRICS_CONTEXT: {
        year: secondThresholdYear,
        years: generateYearArray(firstThresholdYear, 2016),
        minBatTrackingDate,
        minBatTrackingYear: 2023,
    },
    // Okay if this is slow, so an injured player could trend
    trending: {
        year: secondThresholdYear,
    },
    weightedGameScore: {
        year: firstThresholdYear,
    },

    // VISUALS imported
    brushing: {
        currentYear: secondThresholdYear,
        years: generateYearArray(firstThresholdYear, minPitchFxYear),
    },
    SETTINGS_AFFINITY: {
        currentYear: fourthThresholdYear,
    },
    SETTINGS_HITTING_SIGNATURE: {
        currentYear: secondThresholdYear,
        years: generateYearArray(secondThresholdYear, minStatcastYear),
    },
    SETTINGS_PLAYER_COMPARISON: {
        currentYear: secondThresholdYear,
        years: generateYearArray(firstThresholdYear, minPitchFxYear),
    },
    // Flip When Schedule Comes Out
    map: {
        currentYear: 2025,
        years: generateYearArray(2026, 1974),
    },
    oaaVisual: {
        currentYear: secondThresholdYear,
        years: generateYearArray(firstThresholdYear, 2016),
    },
    pitchPercent: {
        currentYear: secondThresholdYear,
        years: generateYearArray(firstThresholdYear, minPitchFxYear),
    },
    pitchPlinko: {
        currentYear: thirdThresholdYear,
        years: generateYearArray(thirdThresholdYear, minPitchFxYear),
    },
    positioning: {
        currentYear: secondThresholdYear,
        years: generateYearArray(firstThresholdYear, 2016),
    },
    swingMissProfile: {
        currentYear: secondThresholdYear,
        years: generateYearArray(secondThresholdYear, minPitchFxYear),
    },
    swingTakeVisual: {
        currentYear: secondThresholdYear,
        years: generateYearArray(secondThresholdYear, minPitchFxYear),
    },
    textureHeatMap: {
        currentYear: secondThresholdYear,
        years: generateYearArray(secondThresholdYear, minPitchFxYear),
    },
    SETTINGS_HOT_STOVE: {
        currentYear: 2026,
        years: generateYearArray(2026, 2020),
        yearsOptions: generateYearArray(2026, 2020).map((d) => ({
            label: `${d - 1} - ${d}`,
            value: d,
        })),
        statYears: generateYearArray(firstThresholdYear, 2019),
        minPa: 100,
        minIp: 20,
        // Magic Numbers
        MAGIC: {
            unsigned: 99887766,
            sameTeam: 99998888,
            diffTeam: 99997777,
        },
    },
    // GAMES
    SETTINGS_SPRAY_CHART_GAME: {
        year: fourthThresholdYear,
    },
    // INTERNAL PAGES
    SETTINGS_PLAYER_RANKING: {
        lastTwoYears: generateYearArray(currentYear, currentYear - 1),
    },
    // PLAYER PAGE
    SETTINGS_PLAYER_PAGE: {
        currentYear: firstThresholdYear,
    },
    SETTINGS_VENUE_INFO: {
        currentYear: firstThresholdYear,
        years: generateYearArray(firstThresholdYear, 2015),
    },
    // CHANGELOG
    SETTINGS_CHANGELOG: {
        currentYear: firstThresholdYear,
        years: generateYearArray(firstThresholdYear, 2025),
    },
}

module.exports = { appSettings, minPitchFxYear, minStatcastYear }
